import dayjs, { Dayjs } from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { ChannelkartNetworkGet,ChannelkartNetworkPost } from "../../services/networkService";
import { User } from "../deleteUserPJP/deleteUserPJP";
dayjs.extend(isSameOrAfter);

export interface DesignationOption {
  value: string;
  label: string;
}

export const fetchDesignationOptions = async (): Promise<DesignationOption[]> => {
    
  const response = await ChannelkartNetworkGet(`/v1/divisions?filter=roleAccessType:app&sort=divisionName:asc`); 
  const rawData = response.data.features;

  const options: DesignationOption[] = rawData.map((item: any) => ({
    value: item.divisionName,
    label: item.divisionName
  }));

  return options;

};


// Get end of the month from a given start date


export const fetchUsersByDesignations = async (
  designations: string[]
): Promise<User[]> => {
  if (designations.length === 0) return [];

  const encodedDesignations = designations.join(",");
  const url = `/users?filter=designation[in]:[${encodedDesignations}] and activeStatus:active&sort=name:asc&size=1000&page=0`;

  const response = await ChannelkartNetworkGet(url);
  const rawData = response.data.features; // Expected to be User[]

  const options: User[] = rawData.map((item: any) => ({
    id: item.loginId,
    name: item.name,
    designation: Array.isArray(item.designation) ? item.designation[0] : item.designation || ""
  }));

  return options;
};
export const fetchUsersByDesignationsPaginated = async (
  designations: string[],
  page: number,
  size: number
): Promise<User[]> => {
  if (designations.length === 0) return [];

  const encodedDesignations = designations.join(",");
  const url = `/users?filter=designation[in]:[${encodedDesignations}] and activeStatus:active&sort=name:asc&size=${size}&page=${page}`;

  const response = await ChannelkartNetworkGet(url);
  const rawData = response.data.features;

  const options: User[] = rawData.map((item: any) => ({
    id: item.loginId,
    name: item.name,
    designation: Array.isArray(item.designation) ? item.designation[0] : item.designation || ""
  }));

  return options;
};

export async function deletePJP(
  users: { id: string }[],
  startDate: dayjs.Dayjs,
  endDate: dayjs.Dayjs
) {
  const payload = {
    loginIds: users.map((u) => u.id),
    startDate: startDate.format("YYYY-MM-DD"),
    endDate: endDate.format("YYYY-MM-DD")
  };

  const deletePJPUrl = `/v1/deliveryPJP/deleteUserPjp`;

  const response = await ChannelkartNetworkPost(deletePJPUrl, payload);

  return response.data;
}


